import React, { useState, useEffect } from 'react';
import axiosInstance from '../../axiosInstance';

const AboutAdmin = () => {
  const [aboutContent, setAboutContent] = useState({ description: '', principles: [] });

  useEffect(() => {
    fetchAboutContent();
  }, []);

  const fetchAboutContent = async () => {
    try {
      const response = await axiosInstance.get('/about');
      setAboutContent(response.data);
    } catch (error) {
      console.error('Error fetching about content:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('principles[')) {
      const index = parseInt(name.match(/principles\[(\d+)\]\.(title|description)/)[1], 10);
      const key = name.match(/principles\[(\d+)\]\.(title|description)/)[2];
      const updatedPrinciples = [...aboutContent.principles];
      updatedPrinciples[index][key] = value;
      setAboutContent({ ...aboutContent, principles: updatedPrinciples });
    } else {
      setAboutContent({ ...aboutContent, [name]: value });
    }
  };

  const handleAddPrinciple = () => {
    setAboutContent({ ...aboutContent, principles: [...aboutContent.principles, { title: '', description: '' }] });
  };

  const handleRemovePrinciple = (index) => {
    const updatedPrinciples = aboutContent.principles.filter((_, i) => i !== index);
    setAboutContent({ ...aboutContent, principles: updatedPrinciples });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(aboutContent);
    try {
      await axiosInstance.put('/about', aboutContent);
      fetchAboutContent();
    } catch (error) {
      console.error('Error updating about content:', error);
    }
  };

  return (
    <div className='max-w-7xl mx-auto px-4'>
      <h1 className="text-4xl font-semibold mb-3 text-gray-900 dark:text-[rgb(211,219,236)]">About</h1>
      <form onSubmit={handleSubmit} className='w-[60%] max-sm:w-full'>
        <div>
          <label className='dark:text-white text-[#111318]'>Description:</label>
          <textarea
            type="text"
            name="description"
            value={aboutContent?.description}
            onChange={handleChange}
            className='block bg-transparent border-[1px] border-gray-600 rounded-md w-full p-2 my-2 text-gray-900 dark:text-[rgb(211,219,236)]'
          />
        </div>
        <div>
          <label className='dark:text-white text-[#111318]'>Principles:</label>
          {aboutContent?.principles?.map((principle, index) => (
            <div key={index} className="mb-4">
              <input
                type="text"
                name={`principles[${index}].title`}
                value={principle.title}
                onChange={handleChange}
                placeholder="Title"
                className='block bg-transparent border-[1px] border-gray-600 rounded-md w-full p-2 my-2 text-gray-900 dark:text-[rgb(211,219,236)]'
              />
              <textarea
                type="text"
                name={`principles[${index}].description`}
                value={principle.description}
                onChange={handleChange}
                placeholder="Description"
                className='block bg-transparent border-[1px] border-gray-600 rounded-md w-full p-2 my-2 text-gray-900 dark:text-[rgb(211,219,236)]'
              ></textarea>
              <button type="button" onClick={() => handleRemovePrinciple(index)} className="bg-red-500 text-white px-2 py-1 rounded-md">
                Remove
              </button>
            </div>
          ))}
          <button type="button" onClick={handleAddPrinciple} className="bg-blue-500 text-white px-4 py-2 rounded-md">
            Add Principle
          </button>
        </div>
        <button type="submit" className='bg-blue-200 dark:bg-yellow-600 px-6 py-3 text-gray-900 dark:text-[rgb(211,219,236)] rounded-md hover:dark:bg-yellow-700 hover:bg-blue-400'>
          Update About
        </button>
      </form>
    </div>
  );
};

export default AboutAdmin;
